import { UserWallet } from '@user/wallet';

let PROGRESSBAR_INITED = false;
const jsonKey = 'game-window-cashback-module.json',
  parentSelector = '.module-cashback-entry';

const userWallet = new UserWallet();

export async function initCashbackProgressBar() {
  if (PROGRESSBAR_INITED) return true;
  PROGRESSBAR_INITED = true;

  const { loadDynamicElement } = await import('@games/window/dynamic/dynamic-elements');

  for (const parentEl of document.querySelectorAll(parentSelector)) {
    try {
      const newElement = await loadDynamicElement(jsonKey);

      if (!newElement) throw new Error('loadDynamicElement() returned null/undefined');

      parentEl.replaceChildren(newElement);
    } catch (error) {
      console.warn('Error using replaceChildren(), trying innerHTML fallback:', error);

      try {
        parentEl.innerHTML = '';
        parentEl.appendChild(await loadDynamicElement(jsonKey));
      } catch (fallbackError) {
        console.error('Critical error while manipulating DOM:', fallbackError);
      }
    }
  }

  userWallet.addObserver(setCashbackProgressBar);
  window.addEventListener('orientationchange', () => setCashbackProgressBar(userWallet.data));

  const { toggleHiddenNotification } = await import('@games/window/service/notification-service');
  toggleHiddenNotification();
}

export async function destroyCashbackProgressBar() {
  if (!PROGRESSBAR_INITED) return true;
  PROGRESSBAR_INITED = false;

  userWallet.removeObserver(setCashbackProgressBar);
  window.removeEventListener('orientationchange', () => setCashbackProgressBar(userWallet.data));

  for (const parentEl of document.querySelectorAll(parentSelector)) {
    parentEl.innerHTML = null;
  }
}

function setCashbackProgressBar(walletData) {
  const walletPoints = walletData?.points;
  if (!walletPoints) return 0;

  const elements = document.querySelectorAll('.js-cashback-progress');
  const isPortrait = +90 != window.orientation;

  for (const element of elements) {
    const forceOrientation = element.getAttribute('data-orientation');
    const elIsPortrait = (isPortrait || forceOrientation == 'portrait') && forceOrientation != 'landscape';

    const parentEl = element.closest('.module-cashback');
    if (!parentEl) continue;

    const points = parentEl.querySelectorAll('.module-cashback-point');

    const pointsDistances = calculateSpaceAroundDistances(points.length);
    const progressDistance = calculateIntervalDistances(walletPoints, points.length) || 0;
    element.style.width = elIsPortrait ? `${progressDistance}%` : null;
    element.style.height = !elIsPortrait ? `${progressDistance}%` : null;
    points.forEach((point, index) => {
      const pointDistance = pointsDistances[index];
      point.classList.toggle('is-active', pointDistance <= progressDistance);
    });
  }
}

function getCashbackPercentage(points) {
  const value = Math.floor(points / 4);
  const overValue = value - 101;
  if (overValue > 0) return (overValue % 25) + 76;
  return value;
}

function calculateSpaceAroundDistances(number) {
  if (number <= 0) return [];

  const distances = [];

  for (let i = 0; i < number; i++) {
    const spaceBefore = ((i * 2 + 1) / (2 * number)) * 100;
    distances.push(spaceBefore);
  }
  return distances;
}

function calculateIntervalDistances(points, number) {
  const value = getCashbackPercentage(points);
  const intervals = 100 / number;
  const distances = calculateSpaceAroundDistances(number);

  if (value < 0 || value > 101) return null;

  let index = Math.floor(value / intervals);
  let intervalPercentage = (value % intervals) / intervals;

  if (index === 0) {
    return distances[0] * intervalPercentage;
  }

  let startDistance = distances[index - 1];
  let endDistance = distances[index === number ? index - 1 : index];

  return startDistance + (endDistance - startDistance) * intervalPercentage;
}

export function forceUpdateCashbackProgressBar() {
  setCashbackProgressBar(userWallet.data);
}
